import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=4ab737a4&scoped=true&"
import script from "./UserRegistration.vue?vue&type=script&lang=js&"
export * from "./UserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&id=4ab737a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab737a4",
  null
  
)

export default component.exports